import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/hosting/shared-hosting")({ beforeLoad: redirectTo("/hosting/web/shared-hosting") });
